// FYI: The video size constants that be threshold for display appropriate size of video overlay.
export const VIDEO_SIZE = {
  LARGE: 350,
  MEDIUM: 225,
  SMALL: 160,
  TINY: 30,
};

export const VIDEO_VARIANTS = { ENDED: 'ENDED', PAUSED: 'PAUSED' };
